// import './trace';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/auth';
import { AppStateProvider } from './contexts/appState';
import { authReducer, authState } from './reducersAndActions/reducers/authReducer';
import { appState, appStateReducer } from './reducersAndActions/reducers/appStateReducer';
import { router } from './Routes';
import { Auth } from './components';
import './styles';
import { ErrorBoundary } from './pages';

const Loader = () => (
  <div id="landingHeader">
    <div
      style={{
        width: '100%',
        backgroundColor: '#1f70d7',
        fontSize: '14px',
        color: '#fff',
        fontWeight: 600,
        height: '58px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      Customer Support
    </div>
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <div style={{ fontSize: '16px', color: '#111', fontWeight: 600 }}>Choose type</div>
      <div style={{ fontSize: '12px', color: '#717171' }}>Do not worry! we will help you to solve problem</div>
    </div>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <Suspense fallback={<Loader />}>
    <ErrorBoundary>
      <AuthProvider reducer={authReducer} authState={authState}>
        <AppStateProvider reducer={appStateReducer} initialState={appState}>
          <Auth>
            <RouterProvider router={router} />
          </Auth>
        </AppStateProvider>
      </AuthProvider>
    </ErrorBoundary>
  </Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
